export default __webpack_public_path__ + "static/media/flaticon.3a1e6c12.woff";